import styled from '@emotion/styled'
import { ITheme } from 'application/utils/type'

interface IInputProps {
  theme: ITheme
  smallerTitleText: boolean
}

export const AccordionShowButton = styled('button')<IInputProps>`
  label: AccordionShowButton;
  background: none;
  border: none;
  color: ${(props) => props.theme.colors.primary};
  > span {
    color: transparent;
    pointer-events: none;
    position: absolute;
  }
`

export const AccordionChildDiv = styled.div<IInputProps>`
  label: AccordionChildDiv;
  color: ${(props) => props.theme.colors.grey2};
  font-size: ${(props) => (props.smallerTitleText ? '16px' : '18px')};
`
